const initialState = {
    url: ''
}

const threeDModel = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default threeDModel;